import React from 'react';

import userManager from '../../userManager';

class SilentRenewIndex extends React.Component<{}, {}> {
    public async componentDidMount() {
        //console.log('Silent renew index invoked');
        const mngr = await userManager;

        try {
            await mngr.signinSilentCallback();
        } catch (e) {
            console.error(e);
        } 
    }

    public render() {
        return null;
    }
}

export default SilentRenewIndex;